export enum CategoryApisActionTypes {
    CATEGORIES_API_RESPONSE_SUCCESS = 'CATEGORIES_API_RESPONSE_SUCCESS',
    CATEGORIES_API_RESPONSE_ERROR = 'CATEGORIES_API_RESPONSE_ERROR',
    GET_CATEGORIES_APIS_DATA = 'GET_CATEGORIES_API_DATA',
}
